import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.svg',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent {
    @HostBinding('style.--help-icon-color')
    @Input()
    color: string;

    @HostBinding('class.fit-content')
    @Input()
    fitContent = false;

    @HostBinding('style.--help-icon-opacity')
    get iconOpacity(): string {
        return this.color ? '1' : null;
    }
}
